import type { Theme, Components } from '@mui/material/styles';

import { radiusValue } from 'src/utils/radius';

import { varAlpha } from '../../styles';

const MuiSkeleton: Components<Theme>['MuiSkeleton'] = {
  defaultProps: { animation: 'wave', variant: 'rounded' },
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: varAlpha(theme.vars.palette.grey['400Channel'], 0.12),
    }),
    rounded: ({ theme }) => ({
      borderRadius: radiusValue(theme, 2), // dùng helper bạn đã tạo
    }),
  },
};

// ----------------------------------------------------------------------

export const skeleton = { MuiSkeleton };
